import { Remarkable } from "remarkable";
import { linkify } from "remarkable/linkify";
import { memoize } from "lodash";

/**
 * Creates a new Remarkable markdown renderer instance with linkify plugin.
 *
 * @param options - Configuration options for Remarkable
 * @returns A new Remarkable instance
 */
export function getNewMarkdownRenderer(options = {}): Remarkable {
  return new Remarkable(options).use(linkify);
}

/**
 * Returns a memoized markdown renderer instance.
 * The same instance is returned on subsequent calls for better performance.
 *
 * @returns A memoized Remarkable instance
 */
export const getMarkdownRenderer = memoize(() => getNewMarkdownRenderer());
